import { atom } from "recoil"

export const trashboxContactsRequestIdState = atom({
  key: "atoms/contact/trashboxContactsRequestIdState",
  default: 0,
})
